import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';
import { ButtonOne } from '../ButtonOne/ButtonOne.component';

export const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalTitle: {
      marginTop: '26px',
      marginLeft: '31px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
      marginBottom: '28px',
    },
    errorMessage: {
      fontFamily: 'Roboto',
      color: '#BC0000',
      fontWeight: 400,
      fontSize: 14,
      marginLeft: '29px',
      marginBottom: '38px',
    },
    errorIcon: {
      height: '20px',
      width: '20px',
      position: 'relative',
      top: '6px',
    },
    formInput: {
      padding: '0px',
      width: '348px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '59px',
      marginRight: '59px',
      marginBottom: '25px',
      appearance: 'none',
    },
    cancelButton: {
      left: '59px',
      bottom: '35px',
      width: '143px',
      height: '36px',
    },
    addUserButton: {
      top: '40px',
      marginLeft: '45px',
      width: '195px',
      height: '35px',
    },
    nextButton: {
      right: '59px',
      bottom: '35px',
      width: '143px',
      height: '36px',
    },
    stageInfo: {
      marginTop: '10px',
    },
  }),
);

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '466px',
      margin: 0,
      padding: 0,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export const CancelButton = withStyles(() => ({
  root: {
    width: '135px',
    padding: '0px 0px 0px 0px',
    height: '36px',
    left: '59px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(Button);

export const NextButton = withStyles(() => ({
  root: {
    position: 'relative',
    marginBottom: '30px',
    width: '135px',
    padding: '0px 0px 0px 0px',
    height: '36px',
    left: '39px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      backgroundColor: '#2C2D3E4D',
      color: '#FFFFFF',
      border: 'none',
      cursor: 'not-allowed',
      pointerEvents: 'none',
    },
  },
}))(ButtonOne);
